export const ArrowSvg = () => {
  return (
    <svg width="5" height="10" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.209209 9.75592C0.466698 10.0563 0.871863 10.0794 1.15207 9.82525L1.21936 9.75592L4.79079 5.58926C5.04828 5.28885 5.06809 4.81616 4.85021 4.48925L4.79079 4.41074L1.21936 0.244078C0.940416 -0.081359 0.488155 -0.0813589 0.209209 0.244078C-0.0482791 0.544481 -0.0680859 1.01717 0.149789 1.34408L0.209209 1.42259L3.275 5L0.209209 8.57741C-0.0482791 8.87781 -0.0680859 9.35051 0.149789 9.67742L0.209209 9.75592Z"
        fill="#176BF2"
      />
    </svg>
  );
};
